import React, { CSSProperties } from 'react';
import { map, split, compact, makeArray, isEmpty, includes } from '../../utils';
import classNames from 'classnames';

interface HighLightTextProps {
    className?: string;
    style?: CSSProperties;
    keywordClassName?: string;
    keywordStyle?: CSSProperties;
    keyword?: string | string[];
    text?: string;
    abbreviated?: boolean;
    title?: boolean;
}

const ABBREVIATIONS_LENGTH = 12;

/**
 * 用于搜索高亮文本
 *
 * @param root0
 * @param root0.style 外层span样式
 * @param root0.className 外层span class
 * @param root0.keywordStyle 关键词 样式
 * @param root0.keywordClassName 关键词 mark class
 * @param root0.keyword 关键词
 * @param root0.text 原文本
 * @param root0.abbreviated // 有keyword时，前面未搜索到的部分超过12个字符，进行缩略
 * @param root0.title
 */
const HighLightText: React.FC<HighLightTextProps> = ({
    style,
    className,
    keywordStyle,
    keywordClassName,
    keyword,
    text,
    abbreviated = true,
    title
}) => {
    const renderContent = () => {
        const sourceKeywords = makeArray(keyword);
        const keywords = map(sourceKeywords, (keyword) =>
            keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        );

        if (
            !text ||
            !keyword ||
            isEmpty(keywords) ||
            !new RegExp(`(${keywords.join('|')})`, 'i').test(text)
        ) {
            return text;
        }

        const parts = compact(split(text, new RegExp(`(${keywords.join('|')})`, 'ig')));
        const lowerCaseKeywords = map(sourceKeywords, (keyword) => keyword.toLowerCase());
        return map(parts, (part, index) => {
            const isKeyword = includes(lowerCaseKeywords, part.toLowerCase());
            if (index === 0 && !isKeyword && abbreviated && part.length > ABBREVIATIONS_LENGTH) {
                return <span key={index}>...{part.slice(part.length - ABBREVIATIONS_LENGTH)}</span>;
            } else if (isKeyword) {
                return (
                    <mark
                        key={index}
                        className={classNames('keyword', keywordClassName)}
                        style={keywordStyle}
                    >
                        {part}
                    </mark>
                );
            } else {
                return <span key={index}>{part}</span>;
            }
        });
    };

    return (
        <span
            className={classNames('fx-hight-light-text', className)}
            style={style}
            title={title ? text : undefined}
        >
            {renderContent()}
        </span>
    );
};

export default HighLightText;
